import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

const TOKEN_KEY = 'wms.accessToken';
const REFRESH_KEY = 'wms.refreshToken';
const USER_KEY = 'wms.user';

export const auth = {
  getAccessToken: () => localStorage.getItem(TOKEN_KEY),
  getRefreshToken: () => localStorage.getItem(REFRESH_KEY),
  getUser: () => {
    try { return JSON.parse(localStorage.getItem(USER_KEY) || 'null'); } catch { return null; }
  },
  set: ({ accessToken, refreshToken, user }) => {
    if (accessToken) localStorage.setItem(TOKEN_KEY, accessToken);
    if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken);
    if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
    window.dispatchEvent(new CustomEvent('wms:auth-changed'));
  },
  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_KEY);
    localStorage.removeItem(USER_KEY);
    window.dispatchEvent(new CustomEvent('wms:auth-changed'));
  },
};

const client = axios.create({
  baseURL: API,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

client.interceptors.request.use((config) => {
  const token = auth.getAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshing = null;
client.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    if (error.response && error.response.status === 401 && !original._retry) {
      const rToken = auth.getRefreshToken();
      if (!rToken) {
        auth.clear();
        return Promise.reject(error);
      }
      try {
        if (!refreshing) {
          refreshing = axios.post(`${API}/auth/refresh`, { refreshToken: rToken }).then((r) => {
            const { accessToken, refreshToken, user } = r.data.data;
            auth.set({ accessToken, refreshToken, user });
            return accessToken;
          }).finally(() => { refreshing = null; });
        }
        const newToken = await refreshing;
        original._retry = true;
        original.headers.Authorization = `Bearer ${newToken}`;
        return client(original);
      } catch (e) {
        auth.clear();
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export default client;

export function apiErrorMessage(err, fallback = 'Something went wrong') {
  return err?.response?.data?.error?.message || err?.message || fallback;
}

export function apiErrorDetails(err) {
  return err?.response?.data?.error?.details || null;
}
